import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Shirt, CheckCircle, Sparkles, Layers, Award, Zap } from 'lucide-react';
export function Embroidery() {
  const capabilities = [{
    icon: <Sparkles className="w-6 h-6" data-id="element-1385" />,
    title: '25 Embroidery Heads',
    description: 'Six state-of-the-art machines for maximum capacity'
  }, {
    icon: <Award className="w-6 h-6" data-id="element-1386" />,
    title: 'In-House Expertise',
    description: 'Skilled designers and specialists handle every detail'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-1387" />,
    title: 'Single to Bulk Orders',
    description: 'From one custom piece to thousands of garments'
  }, {
    icon: <Layers className="w-6 h-6" data-id="element-1388" />,
    title: 'Multiple Locations',
    description: 'Complex designs across multiple garment positions'
  }];
  const materials = [{
    category: 'Apparel',
    items: ['T-Shirts', 'Jackets', 'Hoodies', 'Shorts', 'Work Gloves']
  }, {
    category: 'Accessories',
    items: ['Hats', 'Bags', 'Socks', 'Custom Patches']
  }, {
    category: 'Home Goods',
    items: ['Towels', 'Sherpa Blankets', 'Aprons', 'Robes']
  }, {
    category: 'Baby & Kids',
    items: ['Baby Blankets', 'Birthday Outfits', 'Stockings', 'Parent Matching Sets']
  }, {
    category: 'Equestrian',
    items: ['Horse Blankets', 'Harness Straps', 'Show Apparel']
  }, {
    category: 'Fabrics',
    items: ['Woven Cotton', 'Burlap', 'Denim', 'Linens']
  }];
  return <div className="flex flex-col w-full" data-id="element-1389">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1390">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1391">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1392">
            Award Winning Embroidery
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1393">
            Premium embroidery services that add a professional, lasting touch
            to your apparel and promotional items
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1394">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1395">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-1396">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1397">
              Professional Embroidery That Stands Out
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-1398">
              <p data-id="element-1399">
                At Wear Haus Designs, embroidery isn't just a service—it's our
                craft. Our fully-staffed embroidery department combines skilled
                Graphic Designers and Embroidery Specialists to deliver flawless
                results, whether you need one custom piece or thousands of
                garments with intricate multi-location designs.
              </p>
              <p data-id="element-1400">
                From our humble beginnings with a single embroidery head, we've
                grown to an impressive{' '}
                <span className="font-bold text-wh-pink" data-id="element-1401">
                  25 heads across six state-of-the-art machines
                </span>
                . This powerhouse setup means we can handle any project—from
                delicate baby blankets to rugged horse blankets, elegant towels
                to durable work apparel.
              </p>
            </div>
          </div>

          {/* Work Gallery */}
          <div className="mb-16" data-id="element-1402">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1403">
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1404">
                <img src="https://cdn.magicpatterns.com/uploads/1Meax2py2Zjjw1v2vNNPeX/Embroidery1.png" alt="Embroidery example - Custom embroidered cap" className="w-full h-64 object-cover" data-id="element-1405" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1406">
                <img src="https://cdn.magicpatterns.com/uploads/e3MpPXd9KBNyx7wLAC26uW/Embroidery2.png" alt="Embroidery example - Park Ranger jacket" className="w-full h-64 object-cover" data-id="element-1407" />
              </div>
              <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1408">
                <img src="https://cdn.magicpatterns.com/uploads/hNfcnCC76rXqLnBzS5ceyM/Embroidery3.png" alt="Embroidery example - Tire Star polo shirts" className="w-full h-64 object-cover" data-id="element-1409" />
              </div>
            </div>
          </div>

          {/* Capabilities Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1410">
            {capabilities.map((capability, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-1411">
                <div className="flex items-start gap-4" data-id="element-1412">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white" data-id="element-1413">
                    {capability.icon}
                  </div>
                  <div data-id="element-1414">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1415">
                      {capability.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1416">{capability.description}</p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* What We Embroider */}
          <div className="mb-16" data-id="element-1417">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1418">
              What We Can Embroider
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1419">
              {materials.map((material, index) => <div key={index} className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-wh-pink transition-colors" data-id="element-1420">
                  <h3 className="text-xl font-bold text-wh-teal mb-4" data-id="element-1421">
                    {material.category}
                  </h3>
                  <ul className="space-y-2" data-id="element-1422">
                    {material.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-2" data-id="element-1423">
                        <CheckCircle className="w-5 h-5 text-wh-pink flex-shrink-0 mt-0.5" data-id="element-1424" />
                        <span className="text-gray-700" data-id="element-1425">{item}</span>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>

          {/* Fabric Highlights */}
          <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-2xl p-12 text-white mb-16" data-id="element-1426">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-1427">
              Fabric Versatility
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1428">
              <div data-id="element-1429">
                <h3 className="text-xl font-bold mb-3 text-wh-yellow" data-id="element-1430">
                  Woven Cotton
                </h3>
                <p className="text-white/90" data-id="element-1431">
                  Perfect for quilting weight fabrics and linens—ideal for home
                  goods and apparel.
                </p>
              </div>
              <div data-id="element-1432">
                <h3 className="text-xl font-bold mb-3 text-wh-yellow" data-id="element-1433">
                  Burlap
                </h3>
                <p className="text-white/90" data-id="element-1434">
                  Durable and shape-retaining, perfect for rustic designs and
                  specialty items.
                </p>
              </div>
              <div data-id="element-1435">
                <h3 className="text-xl font-bold mb-3 text-wh-yellow" data-id="element-1436">Denim</h3>
                <p className="text-white/90" data-id="element-1437">
                  Heavyweight fabric that showcases modern embroidery with bold,
                  lasting results.
                </p>
              </div>
              <div data-id="element-1438">
                <h3 className="text-xl font-bold mb-3 text-wh-yellow" data-id="element-1439">
                  Custom Patches
                </h3>
                <p className="text-white/90" data-id="element-1440">
                  Embroidered patches for hats, jackets, work shirts, and
                  more—built to last.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Box */}
          <div className="bg-gradient-to-br from-wh-pink to-pink-600 rounded-2xl p-12 text-center text-white" data-id="element-1441">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1442">
              Ready to Bring Your Vision to Life?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1443">
              No matter your project, we logo YOUR life with precision and
              flair. From baby blankets to business uniforms, we've got you
              covered.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1444">
              <a href="/Contact" className="inline-flex items-center justify-center px-8 py-4 bg-white text-wh-pink font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1445">
                Get a Quote
              </a>
              <a href="/services" className="inline-flex items-center justify-center px-8 py-4 bg-wh-yellow text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-colors" data-id="element-1446">
                View All Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1447" />
    </div>;
}